module.exports = __webpack_public_path__ + "media/images/lamp/green-00cff6a1e1f0d50a844fbf64e1f5eabd.png";